export const manageIndexes = {
  filterIndexes: 'Show indexes',
  all: 'All',
  withIndex: 'With indexes',
  withoutIndex: 'Without indexes',
  option: '[option]',
  dynamic: 'Generated dynamically based on chosen option',
} as const
